/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientData } from '../../models/client-data';

export interface ClientManagementSaveClientSetupSaveClientSetupPost$Params {
      body?: ClientData
}

export function clientManagementSaveClientSetupSaveClientSetupPost(http: HttpClient, rootUrl: string, params?: ClientManagementSaveClientSetupSaveClientSetupPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, clientManagementSaveClientSetupSaveClientSetupPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

clientManagementSaveClientSetupSaveClientSetupPost.PATH = '/ClientManagement/SaveClientSetup/SaveClientSetup';
